import * as React from 'react';
import '../Spinner/spinner.css';

const Spinner = () => {


    React.useEffect(()=>{
         $('#overlay').fadeIn();

    },[]);

    return (
        <>
          {/*  <div area-hidden="true" className='mainDiv' style={{ opacity: "1", transition: "opacity 225ms cubic-bezier(0.4), 0, 0.2, 1" }}>
                <span className='inside-div'>
                    <div>
                        <span className='Loading__spinner' style={{ zIndex: 999 }}>
                             <img className='logo' src='assets/img/spinner/loader.gif'></img> 

                        </span>

                    </div>
                </span>
            </div>
            */}

<div id="overlay" style={{display:"none"}}>
    <div className="spinner"></div>
    Loading...
</div>


        </>
    );

}
export default Spinner;